<template>
    <div>
        <div class="row" style="margin-top: 1rem; margin-bottom: 1.5rem;">
            <div class="col-12 text-center">
                <span class="material-icons" :style="iconStyle" v-html="icon"></span>
            </div>
            <div class="col-12 text-center" style="margin-bottom: 1rem;">
                <h3>{{ title }}</h3>
                <p v-if="detail">{{ detail }}</p>
            </div> 
            <div v-if="showTryAgain" class="col-12 text-center">
                <ui-button color="default" @click="$emit('retry')">{{ buttonLabel }}</ui-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                required: true
            },
            detail: {
                type: String,
                required: false,
                default: ''
            },
            showTryAgain: {
                type: Boolean,
                default: false
            },
            loading: {
                type: Boolean,
                required: false,
                default: false
            },
            icon: {
                type: String,
                required: false,
                default: 'warning'
            },
            accentColour: {
                type: String,
                required: false,
                default: 'gold',
            },
            buttonLabel: {
                type: String,
                required: false,
                default: 'Try Again'
            }
        },
        computed: {
            iconStyle() {
                let styles = {}

                styles.fontSize = '3rem'
                styles.color = this.accentColour;

                return styles
            }
        }
    }
</script>